import React from 'react';
// import { Tooltip } from 'react-tooltip';
import MONEYBACK from '../images/14daymoneyback.png';
import MONEYBACKW from '../images/14daymoneyback.webp';
import BasicSupport from './BasicSupport';
import PremiumSupport from './PremiumSupport';
import { ImgW } from '../js';
import Price from './Price';
import HandLApps from './HandLApps';
import MultiEnvironments from './MultiEnviroments';

function Prices() {
  return (
    <section className='row prices m-t-80 p-b-80' id='prices'>
      <div className='container max-w-screen-xl mx-auto px-12'>
        <h3 className='text-center m-b-40 text-[24px] font-medium'>
          The <span className='wp-title'>highest rated</span> and{' '}
          <span className='wp-title'>most downloaded</span> WordPress UTM
          tracking plugin.
          <br /> Over <span className='wp-title'>100,000+</span>
          sites trust HandL UTM Grabber to grow their business with confidence.
        </h3>
        <div className='flex flex-wrap pricesRow seven-cols justify-center'>
          <Price
            first='true'
            plan='premium'
            colorClass='blue4'
            features={
              <ul>
                <PremiumSupport />
                <li>Customization</li>
                <li>24/7 Chat & Email</li>
                
                <HandLApps />
              </ul>
            }
            logo='bluev3'
          />

          <Price
            plan='starterp'
            colorClass='blue3'
            features={
              <ul>
                <BasicSupport />
                <MultiEnvironments/>
                <HandLApps />
              </ul>
            }
            logo='bluev3'
            bestseller='true'
          />

          <Price
            plan='starter'
            colorClass='blue1'
            features={
              <ul>
                <BasicSupport />
              </ul>
            }
            logo='bluev3'
          />
          <Price plan='free' colorClass='orange1' features='' logo='orangev2' />
        </div>

        <div className='lg:flex md:flex sm:block mt-[20px] items-center xl:w-[1170px] mx-auto'>
          <div className='basis-1/4 flex justify-center px-[15px]'>
            <ImgW
              src={MONEYBACKW}
              fallback={MONEYBACK}
              className='img-responsive'
            />
          </div>
          <div className='basis-3/4 moneyback px-[15px]'>
            <h2 className='text-[35px] font-medium mt-[20px] mb-[10px]'>
              Risk-Free 14 Days Money Back Guarantee
            </h2>
            <ul className='pl-[40px]'>
              <li>
                Buy HandL UTM license(s) now{' '}
                <span className='font-bold'>completely risk-free</span>.
              </li>
              <li>
                Your investment is covered by no-hassle money back guaranteed
                for <span className='font-bold'>14 days</span>.
              </li>
              <li>
                In the highly unlikely event, you don't feel HandL UTM Grabber
                lives up to every claim on this page, just &nbsp;
                <button
                  className='pointer text-[#1972f5]'
                  onClick={() => {
                    window.$crisp.push(['do', 'chat:toggle']);
                  }}
                >
                  let us know
                </button>
                . We'll be happy to work with you to find solution. If you are
                still unsatisfied, we'll{' '}
                <span className='font-bold'>
                  return 100% of your investment
                </span>
                .
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Prices;
